import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getMainSlider(Redis, domain, reset = false) {
    return redisGetHandler(
      false,
      axios,
      config.API_URL,
      `/landings/getMainBanner?domain=${domain}`,
      true,
    );
  },
  // Где вызывается: сервер.
  async getMainAdv(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/landings/getMainAdv",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getModels(Redis, domain, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/landings/getModels?domain=${domain}`,
      reset,
    );
  },
  // Где вызывается: не используется.
  async getMainNews(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/landings/getMainNews",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMeta(Redis, domain, page, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/landings/getMeta?domain=${domain}&page=${page}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainProblemsFirst(Redis, domain, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/landings/getMainProblemsFirst?domain=${domain}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainProblemsSecond(Redis, domain, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/landings/getMainProblemsSecond?domain=${domain}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainReviews(Redis, domain, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/landings/getMainReviews?domain=${domain}`,
      reset,
    );
  },
});
